import { WHEELS, INTERIOR } from '../common/steps';

const computeMoreViewsPath = (activeStep) => {
  const displayExterior = activeStep !== INTERIOR;
  const angle = activeStep === WHEELS ? 'profile' : null;

  let search = `?isExterior=${displayExterior}`;
  if (angle) {
    search = `${search}&angle=${angle}`;
  }
  return {
    pathname: 'moreviews',
    search,
  };
};

export default computeMoreViewsPath;
